import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  locale: string;
}

const Html = ({ children, locale }: Props) => (
  <html lang={locale} className="h-full">
    {children}
  </html>
);

export default Html;
